import { colors } from '@noths/polaris-client-ribbons-design-system';
import { theme } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts } = theme;

export const loadMoreButton = (spinnerClassName: string, animationDuration: number) => css`
  background: ${colors.brandBluePrimary};
  border-radius: 6px;
  color: #fff;
  display: inline-block;
  font-family: ${fonts.PRIMARY_REGULAR.family}, sans-serif;
  font-size: 1rem;
  font-weight: 600;
  min-width: 12rem;
  height: 3rem;
  line-height: 3;
  padding: 0 0.5rem;
  margin: 0 0 1rem;
  text-decoration: none;

  &:active {
    transform: scale(0.98);
  }

  .${spinnerClassName}-enter {
    transform: scale(0.1);
  }
  .${spinnerClassName}-enter-active {
    transform: scale(1);
    transition: transform ${animationDuration}ms ease-in;
  }
  .${spinnerClassName}-exit {
    transform: scale(1);
  }
  .${spinnerClassName}-exit-active {
    transform: scale(0.1);
    transition: transform ${animationDuration}ms;
  }
`;

export const loadingSpinner = css`
  padding: 8px;
`;
